// Currency + number formatting utilities
const CURRENCY_SYMBOLS = { PHP: "₱", USD: "$", EUR: "€", GBP: "£", INR: "₹", JPY: "¥", CNY: "¥" };

export function formatCurrency(amount, currency = "PHP", opts = {}) {
    if (amount == null || amount === "") return "—";
    const num = Number(amount);
    if (Number.isNaN(num)) return String(amount);
    const symbol = CURRENCY_SYMBOLS[currency] || currency + " ";
    const { fractionDigits = 2, compact = false } = opts;
    if (compact && Math.abs(num) >= 1000) {
        const units = [["B", 1e9], ["M", 1e6], ["K", 1e3]];
        for (const [suffix, div] of units) {
            if (Math.abs(num) >= div) {
                return `${symbol}${(num / div).toFixed(1)}${suffix}`;
            }
        }
    }
    return `${symbol}${num.toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })}`;
}

export function formatNumber(n, opts = {}) {
    if (n == null) return "—";
    const { fractionDigits = 0 } = opts;
    return Number(n).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}

export function formatPct(n, fractionDigits = 1) {
    if (n == null) return "—";
    return `${Number(n).toFixed(fractionDigits)}%`;
}
